<div class="radio-button">
  <input class="radio-button__input" type="radio" name="product" checked data-testid="radio-button-input" />
  <span class="radio-button__icon"></span>
  <span class="radio-button__outline"></span>
  <span class="radio-button__label"><ng-content></ng-content></span>
</div>
